<template>
  <span v-on:click="expandCard">
    <div class="js-task-title">
      <div class="row" v-if="expanded">
        <div class='d-flex col-10 lg-icon d-print-none' ref="taskPropertyLinks">
          <!-- <QTDueDate :task="task" v-if="this.task.kind == 'todo' || this.task.kind == 'document'" /> -->
          <!-- <QTManageContacts :task="task" /> -->
          <!-- <QTManageTags :task="task" /> -->
          <QTManageProject :task="task" />
          <QTAttachFile :task="task" v-if="this.task.kind == 'todo' || this.task.kind == 'document'" />
          <QTEmailTask :task="task" />
          <!-- <router-link v-if="this.task.kind == 'todo' || this.task.kind == 'document'" class="text-secondary" :to="{ name: 'todo', params: { task_id: task.id } }">
            <i class="material-icons pointer ml-1">open_in_new</i>
          </router-link> -->
          <i v-if="singleView" class="material-icons pointer ml-1" @click="printWindow()">printer</i>
        </div>
        <div class='col-2'>
        <div class='float-right d-flex align-items-center d-print-none'>
            <QTRestoreTask :task="task"/>
            <QTMoveTask :task="task"/>
            <QTDeleteTask :task="task"/>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="sortable" class='float-right d-flex align-items-center'>
          <i class="material-icons pointer ml-1 sort-handle">reorder</i>
        </div>
      </div>
      <QuickTaskTitle :task="task" :containerExpanded="expanded" :titleEditing="titleEditing" />

      <div class="collapse mt-1 mb-1 js-task-details-collapse" :id="taskDetailsCollapseId(task)">
        <QuickTaskHtmlNotes :task="task" v-if="task.html_notes && expanded"/>
        <QuickTaskNotes :task="task"  :containerExpanded="expanded" v-if="!task.html_notes"/>

          <NewTaskItem :task="task" v-if="!task.discarded && this.task.kind == 'todo'"/>

          <ul class="list-group mt-2">
            <li class="list-group-item" v-for="(task_item, index) in task.task_items" :key="task_item.id">
              <TaskItem :task_item="task_item" :task="task" :index="index" />
            </li>
            <li class="list-group-item" v-for="file in task.files" :key="file.id">
              <QuickAttachedFile :file="file" :task="task"/>
            </li>
          </ul>
      </div>
      <QuickTaskDate :task="task"/>
    </div>
  </span>
</template>

<script>
import api from "api";
import TaskItem from "components/TaskItem";
import NewTaskItem from "components/NewTaskItem";
import QuickAttachedFile from "components/QuickAttachedFile";
import Tag from "components/Tag";
import Contact from "components/Contact";
import QuickTaskDate from "components/QuickTaskDate";
import QuickTaskTitle from "components/QuickTaskTitle";
import QuickTaskNotes from "components/QuickTaskNotes";
import QuickTaskHtmlNotes from "components/QuickTaskHtmlNotes";
import QTAttachFile from "components/quick_task/AttachFile"
import QTDueDate from "components/quick_task/DueDate"
import QTManageTags from "components/quick_task/ManageTags"
import QTManageContacts from "components/quick_task/ManageContacts"
import QTManageProject from "components/quick_task/ManageProject"
import QTRestoreTask from "components/quick_task/RestoreTask"
import QTMoveTask from "components/quick_task/MoveTask"
import QTDeleteTask from "components/quick_task/DeleteTask"
import QTEmailTask from "components/quick_task/EmailTask"

export default {
  components: {
    TaskItem,
    NewTaskItem,
    QuickTaskDate,
    Tag,
    Contact,
    QuickAttachedFile,
    QuickTaskTitle,
    QuickTaskHtmlNotes,
    QuickTaskNotes,
    QTAttachFile,
    QTDueDate,
    QTManageTags,
    QTManageContacts,
    QTManageProject,
    QTRestoreTask,
    QTMoveTask,
    QTDeleteTask,
    QTEmailTask
  },
  props: {
    task: {
      type: Object
    },
    project: {
      type: Object
    },
    sortable: {
      type: Boolean
    },
    singleView: {
      type: Boolean
    },
  },
  mounted() {
    $(document).on('click touchstart', function(event) {
      if (!$(event.target).parents('.js-task-details-collapse-container').length) {
        // Hide the cards
        if(event.target.className != 'tags-input-remove' && !event.target.className.split(' ').includes('do-not-collapse')){
          $('.js-task-details-collapse').collapse('hide')
          this.expanded = false
        }
      }

      if (!$(event.target).parents('.js-new-item ').length) {
        // Hide Forms
        $('#js-todo-form').removeClass('d-block');
        $('#js-note-form').removeClass('d-block');
      }
    }.bind(this));
  },
  data() {
    return {
      tagEditing: false,
      expanded: false,
      selectedTags: this.task.formatted_tag_list,
      allTags: this.$store.state.user_tags,
      titleEditing: false
    };
  },
  methods: {
    taskDetailsCollapseId(task){
      return 'task-details-collapse-' + task.id
    },
    expandCard(event){
      this.expanded = true

      var card = $(event.target).closest('.js-task-details-collapse-container')[0]
      var collapse = $(card).find('.js-task-details-collapse')[0]
      $(collapse).collapse('show')

      if(collapse){
        $('.js-task-details-collapse').not('#' + collapse.id).collapse('hide')
      }
    },
    taskEditable(){
      return !this.task.discarded
    },
    restoreTask(task){
      this.$parent.restoreTask(task);
    },
    disableTitleEditing(){
      this.titleEditing = false;
    },
    printWindow(){
      window.print();
    }
  }
}
</script>
